import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useLocation } from 'react-router-dom'

interface Props {
  open: boolean
  handleClose: () => void
}

export default function AlertDataComplements({
  open,
  handleClose,
}: Props): JSX.Element {
  const location = useLocation()
  const useStyles = makeStyles(() => ({
    boxHeader: {
      backgroundColor: '#442771',
    },
    textName: {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.1px',
      color: '#fff',
    },
    textUnidade: {
      fontWeight: 'normal',
      fontSize: '18px',
      lineHeight: '23px',
      textTransform: 'capitalize',
      color: '#737B7D',
      paddingBottom: '20px',
      paddingTop: '20px',
    },
    btnConfirm: {
      backgroundColor: '#3CD278',
      border: 'none',
      color: '#FFFFFF',
      borderRadius: '0',

      padding: '10px',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#00a04b',
      },
    },
    btnClose: {
      backgroundColor: '#b0bec5',
      border: 'none',
      color: '#FFFFFF',
      borderRadius: '0',

      padding: '10px',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#808e95',
      },
    },
  }))
  const classes = useStyles()

  const updateForDataComplements = () => {
    try {
      sessionStorage.setItem('@data-complements', 'true')
    } catch (error) {
      console.log(error)
    }
  }

  const handleRedirect = () => {
    if (location.pathname.includes('manifestacao')) {
      localStorage.setItem('@path-complements-return', location.pathname)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" className={classes.boxHeader}>
        <Typography className={classes.textName}>
          Olá! Identificamos que seus dados estão desatualizados. Gostaríamos de
          atualizá-los para garantir um atendimento adequado?
        </Typography>
      </DialogTitle>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.btnConfirm}
          href="/workspace/minha-conta/meus-dados"
          onClick={() => handleRedirect()}
        >
          Sim, preencher
        </Button>
        <Button
          onClick={() => {
            handleClose()
            updateForDataComplements()
          }}
          variant="contained"
          color="primary"
          className={classes.btnClose}
        >
          Não, depois faço isso
        </Button>
      </DialogActions>
    </Dialog>
  )
}
